import React from "react";
import ElitePopup from "ComponentsUI/ElitePopup";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import routes from "Configs/routes";
import LazyImage from "ComponentsUI/Image";

export default class OperatorItemBasis extends React.Component {
	static defaultProps = {
		onOperatorSelect: () => {},
		onOperatorConnect: () => {},
	};

	generateCommonPart() {
		let text = this.props.text;
		return (
			<React.Fragment>
				{this.props.data.vip_provider == 1 && (
					<ElitePopup flat={this.props.flat} text1={text.ELITE_TEXT_1} text2={text.ELITE_TEXT_2} />
				)}
			</React.Fragment>
		);
	}

	preventRedirect(e) {
		if (!this.props.data.reviews_info.count_total) {
			e.preventDefault();
		}
	}

	generateButton() {
		const { text, classes, data } = this.props;
		const pathToOperator = generateUrl(routes.OperatorDetails.route, {
			operator: data.url_name,
			regionUrl: data.region.url,
		});

		return (
			<NavLink to={pathToOperator} className={classNames(classes.buttons)}>
				<div className={classes.buttonsItem} data-test="operators_operator_connect_button">
					<span className={classes.buttonsItemText}>
						{text.tariffsReadMore}
						{/* {text.connect} */}
					</span>
				</div>
			</NavLink>
		);
	}

	preventPropagation(e) {
		e.stopPropagation();
	}

	generateLogo(item) {
		const classes = this.props.classes;
		const src = !!this.props.webpTransformer
			? this.props.webpTransformer(this.props.generateLogoPath(item))
			: this.props.generateLogoPath(item);

		return React.cloneElement(this.props.linkComponent, {
			"aria-label": `Мобильные тарифы ${item.name}`,
			to: this.props.generateOperatorTariffUrl(item),
			className: classes.logoWrapper,
			children: <LazyImage src={src} className={classes.logo} alt={item.name} />,
		});
	}
}
